export default "__VITE_ASSET__D8rg$JfE__"